import React from "react";
import { Controller } from "react-hook-form";
import get from "lodash/get";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const CheckboxController = ({ name, control, rules, label, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              {...field}
              {...props}
              checked={field.value}
              sx={{
                "&.Mui-checked": {
                  color: "var(--red-color)",
                },
                ...get(props, "sx", {}),
              }}
            />
          }
          label={label}
        />
      )}
    />
  );
};

export default CheckboxController;
